import {HttpClient} from "@angular/common/http";
import {tap} from "rxjs/operators";


export function getBaseUrl() {
  return (document.getElementsByTagName('base')[0].href + '/').replace(/([^:]\/)\/+/g, '$1');
}

export const appInitializerFn = (environment: {
  production: boolean,
  version: string
}, httpClient: HttpClient) => {
  return () => httpClient.get("/api/config/version")
    .pipe(
      tap(version => {
        environment.version = version as string;
      })
    );
};

export const baseSvgConfigFn = (environment: {
  production: boolean,
  version: string
}) => {
  return {
    baseUrl: `/assets/img/sprite.svg?v=` + environment.version
  }
};
